import { useState, FC } from 'react';
import { Grid } from '@mui/material';
import Notification, { NotificationElement } from './Notification';
import { useGetNotificationsStatusQuery, useUpdateNotificationsStatusMutation } from 'src/redux/services/notifications';
import FailureScreen from 'src/frontend-common/components/FailureScreen';
import { useDebouncedCallback } from 'use-debounce';
import Column from 'src/frontend-common/components/Column';
import Row from 'src/frontend-common/components/Row';
import { WhiteContainer, ContainerCard, TypographyGridTitle } from 'src/style/common';
import SnackBarCompleteHandler from 'src/components/SnackBarCompleteHandler';

const NotificationsInfo: FC = () => {
  const { data, isError, isLoading } = useGetNotificationsStatusQuery();
  const [allSwitchesDisabled, setAllSwitchesDisabled] = useState<boolean>(false);
  const [updateNotification, { isError: updateIsError, isSuccess: updateIsSuccess, error: updateErrorMessage }] = useUpdateNotificationsStatusMutation();
  const notifications: NotificationElement[] = [
    {
      title: 'Product updates',
      description: 'News, announcements, and product updates.',
      status: data?.item.is_subscribed_to_product_updates ? data?.item.is_subscribed_to_product_updates : false,
    },
    {
      title: 'Incident updates',
      description: 'Important service outage or API issue notifications.',
      status: data?.item.is_subscribed_to_status_page ? data?.item.is_subscribed_to_status_page : false,
    },
  ];

  const debouncedCallback = useDebouncedCallback(() => setAllSwitchesDisabled(false), 2000);

  const handleUpdateNotification = (notificationName: string, status: boolean) => {
    if (data) {
      debouncedCallback.callback();
      setAllSwitchesDisabled(true);
      updateNotification({
        is_subscribed_to_product_updates: notificationName === 'Product updates' ? status : data.item.is_subscribed_to_product_updates,
        is_subscribed_to_status_page: notificationName === 'Incident updates' ? status : data.item.is_subscribed_to_status_page,
      });
    }
  };

  const loadingNotifications = notifications.map((notification) => (
    <Notification key={notification.title} singleNotification={notification} updateNotification={handleUpdateNotification} isLoading={true} />
  ));

  return (
    <>
      <WhiteContainer container={true}>
        <Grid item={true} xs={12} md={3} lg={3} xl={3}>
          <ContainerCard>
            <TypographyGridTitle variant="h5">Email</TypographyGridTitle>
          </ContainerCard>
        </Grid>

        <Grid item={true} xs={12} md={9} lg={9} xl={9}>
          <Column>
            <>
              {isLoading && loadingNotifications}
              {!isError &&
                data &&
                notifications.map((notification) => (
                  <Row key={notification.title}>
                    <Notification singleNotification={notification} updateNotification={handleUpdateNotification} isDisabled={allSwitchesDisabled} />
                  </Row>
                ))}
              {isError && (
                <FailureScreen minHeigth={10} align="flex-start">
                  Error! Could not fetch notifications status
                </FailureScreen>
              )}
            </>
          </Column>
        </Grid>
      </WhiteContainer>
      <SnackBarCompleteHandler
        isSuccess={updateIsSuccess}
        isError={updateIsError}
        error={updateErrorMessage}
        successMessage="Notification status updated successfully"
      />
    </>
  );
};

export default NotificationsInfo;
